import { Directive, Input, ElementRef, Renderer2, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[nimbusButtonGroupElement]',
  standalone: false,
})
export class NimbusButtonGroupElementDirective {
  @Input()
  public value: any;
  @Output() public clickEvent: EventEmitter<any> = new EventEmitter<any>();
  private isDisabled: boolean;
  private isActive: boolean;

  public constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (isDisabled) {
      this.renderer.setAttribute(this.el.nativeElement, 'disabled', 'disabled');
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'disabled');
    }
  }

  public setActiveState?(isActive: boolean): void {
    this.isActive = isActive;
    if (this.isActive) {
      this.renderer.addClass(this.el.nativeElement, 'active');
      this.el.nativeElement.setAttribute('aria-pressed', '');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'active');
      this.el.nativeElement.removeAttribute('aria-pressed');
    }
  }

  @HostListener('click')
  public click(): void {
    if (this.isDisabled) {
      return;
    }
    this.clickEvent.emit(this.value);
  }
}
